module.exports = __webpack_public_path__ + "media/icons/spinner-0390b663a391b84e535ccd085c3628df.svg";